import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "tab-content w-100" }
const _hoisted_5 = {
  class: "row m-0 bg-card-light",
  style: {"border-radius":"10px 10px 0px 0px"}
}
const _hoisted_6 = { class: "col-md-4 d-flex justify-content-start py-4" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = {
  class: "font-size-16 font-grey p-cursor",
  onclick: "location.href='https://map.admin.caprock.com.au/edit-customer/54?type=view'"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"35px","margin":"0 15px"},
  src: "https://map.admin.caprock.com.au/inlancer-admin/images/users-sqr.svg"
}, null, -1)
const _hoisted_10 = {
  key: 0,
  style: {"color":"#6B7A99"}
}
const _hoisted_11 = {
  key: 1,
  style: {"color":"#6B7A99"}
}
const _hoisted_12 = { class: "col-md-6 d-flex justify-content-center align-items-center py-4" }
const _hoisted_13 = { class: "nav justify-content-center" }
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("b", { class: "font-grey" }, "Profile", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "nav-item" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("b", { class: "font-grey" }, "External Banks", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("b", { class: "font-grey" }, "Managing Members", -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("b", { class: "font-grey active" }, "Beneficial Owners", -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "nav-item" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("b", { class: "font-grey" }, "Accounts", -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 d-flex justify-content-end align-items-center py-4" }, null, -1)
const _hoisted_30 = { class: "my-4 mx-4 p-0 bg-white border-radius-10" }
const _hoisted_31 = { class: "p-4 mb-4 bg-card-light border-radius-10 h-100" }
const _hoisted_32 = { class: "row mt-3 mx-1" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-flex justify-content-between mb-2" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "font-grey font-size-14" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Beneficial Owners")
    ])
  ])
], -1)
const _hoisted_34 = { class: "col-6" }
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<div class=\"row my-3 mx-1\"><div class=\"col-md-1\"><label class=\"font-grey mx-2\">No</label></div><div class=\"col-md-5\"><label class=\"font-grey mx-2\">Owner Name</label></div><div class=\"col-md-6\"><label class=\"font-grey mx-2\">Address</label></div></div>", 1)
const _hoisted_36 = {
  key: 0,
  id: "results"
}
const _hoisted_37 = { class: "col-md-1" }
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = { class: "beneficiary_tag" }
const _hoisted_40 = { class: "col-md-5" }
const _hoisted_41 = {
  class: "form-group",
  style: {"overflow":"auto"}
}
const _hoisted_42 = { class: "beneficiary_tag" }
const _hoisted_43 = { class: "col-md-6" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = { class: "beneficiary_tag" }
const _hoisted_46 = {
  key: 1,
  id: "results"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", { class: "beneficiary_tag text-center font-grey font-size-14" }, "No Data Found !!", -1)
const _hoisted_48 = [
  _hoisted_47
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_right_side = _resolveComponent("right-side")!
  const _component_toasti = _resolveComponent("toasti")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic, { load_on: _ctx.load_on }, null, 8, ["load_on"]),
    _createVNode(_component_right_side, {
      user_info: _ctx.user_info,
      customer_accounts: _ctx.customer_accounts
    }, null, 8, ["user_info", "customer_accounts"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _createElementVNode("h5", _hoisted_8, [
                    _hoisted_9,
                    (_ctx.user_info.u_type!=2)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_10, _toDisplayString(_ctx.user_info.user_name), 1))
                      : _createCommentVNode("", true),
                    (_ctx.user_info.u_type==2)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_11, _toDisplayString(_ctx.user_info.user_company_name), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("ul", _hoisted_13, [
                  _createElementVNode("li", _hoisted_14, [
                    _createElementVNode("a", {
                      class: "nav-link",
                      "aria-current": "page",
                      href: "javascript:;",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/my-profile')))
                    }, _hoisted_16)
                  ]),
                  _createElementVNode("li", _hoisted_17, [
                    _createElementVNode("a", {
                      class: "nav-link",
                      "aria-current": "page",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/bank-accounts'))),
                      href: "javascript:;"
                    }, _hoisted_19)
                  ]),
                  (_ctx.user_info.is_directors==1)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                        _createElementVNode("a", {
                          class: "nav-link",
                          "aria-current": "page",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/managing-members'))),
                          href: "javascript:;"
                        }, _hoisted_22)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.user_info.is_owners==1)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                        _createElementVNode("a", {
                          class: "nav-link",
                          "aria-current": "page",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/beneficial-owners'))),
                          href: "javascript:;"
                        }, _hoisted_25)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", _hoisted_26, [
                    _createElementVNode("a", {
                      class: "nav-link",
                      href: "javascript:;",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/my-accounts')))
                    }, _hoisted_28)
                  ])
                ])
              ]),
              _hoisted_29
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("input", {
                      onKeyup: _cache[5] || (_cache[5] = ($event: any) => {_ctx.textSearch($event);}),
                      style: {"border":"1px solid grey !important","height":"35px","float":"right","border-radius":"5px !important"},
                      type: "text",
                      id: "doc_search_input",
                      placeholder: "Search owner (beneficial) name here..",
                      class: "bg-white w-100 pl-3"
                    }, null, 32)
                  ])
                ]),
                _hoisted_35,
                (_ctx.owners.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.owners, (owner) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: owner.owner_id,
                          class: "row my-1 mx-1 docss"
                        }, [
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("p", _hoisted_39, [
                                _createElementVNode("span", null, _toDisplayString(owner.no), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("p", _hoisted_42, _toDisplayString(owner.owner_name), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("p", _hoisted_45, _toDisplayString(owner.owner_address), 1)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.owners.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, _hoisted_48))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_toasti, { ref: "toasti" }, null, 512)
  ], 64))
}